import clsx from 'clsx'

import type { PropsWithClassName } from '@fv/client-types'
import type { RouteGuideStepStatus } from '@fv/models'

const labels: Record<RouteGuideStepStatus, string> = {
  pending: 'Pending',
  tendered: 'Tendered',
  accepted: 'Accepted',
  rejected: 'Declined',
  'timed-out': 'Timed out',
  skipped: 'Skipped',
  retracted: 'Retracted',
}

export const RouteGuideStepBadge = ({
  className,
  status,
}: PropsWithClassName<{ status: RouteGuideStepStatus }>) => (
  <div
    className={clsx(
      'text-xs p-1 rounded-sm w-[4.5rem] flex items-center justify-center shrink-0',
      className,
      {
        'bg-fv-gray-100 border-fv-gray-300 border':
          status === 'pending' || status === 'skipped',
        'bg-fv-green-100 border-fv-green-300 border':
          status === 'tendered' || status === 'accepted',
        'bg-fv-red-50 border border-fv-red-200':
          status === 'rejected' ||
          status === 'timed-out' ||
          status === 'retracted',
      },
    )}
  >
    {labels[status]}
  </div>
)
